(function () {
  'use strict';

  var pdfLibPromise = null;

  function loadPdfLib(src) {
    if (window.PDFLib) return Promise.resolve();
    if (pdfLibPromise) return pdfLibPromise;
    pdfLibPromise = new Promise(function (resolve, reject) {
      var existing = document.querySelector('script[data-specsheet-pdf-lib]');
      if (existing) {
        existing.addEventListener('load', function () { resolve(); });
        existing.addEventListener('error', reject);
        return;
      }
      var s = document.createElement('script');
      s.src = src;
      s.setAttribute('data-specsheet-pdf-lib', 'true');
      s.onload = function () { resolve(); };
      s.onerror = reject;
      document.head.appendChild(s);
    });
    return pdfLibPromise;
  }

  function sniffType(bytes) {
    var b = new Uint8Array(bytes);
    if (b[0] === 0x25 && b[1] === 0x50 && b[2] === 0x44 && b[3] === 0x46) return 'pdf';
    if (b[0] === 0xFF && b[1] === 0xD8) return 'jpg';
    if (b[0] === 0x89 && b[1] === 0x50 && b[2] === 0x4E && b[3] === 0x47) return 'png';
    return 'unknown';
  }

  function addToMerged(merged, bytes, url) {
    var kind = sniffType(bytes);

    if (kind === 'pdf') {
      return window.PDFLib.PDFDocument.load(bytes).then(function (src) {
        return merged.copyPages(src, src.getPageIndices());
      }).then(function (pages) {
        pages.forEach(function (p) { merged.addPage(p); });
      });
    }

    if (kind === 'jpg' || kind === 'png') {
      var embed = kind === 'jpg' ? merged.embedJpg(bytes) : merged.embedPng(bytes);
      return Promise.resolve(embed).then(function (img) {
        var page = merged.addPage([img.width, img.height]);
        page.drawImage(img, { x: 0, y: 0, width: img.width, height: img.height });
      });
    }

    throw new Error('Unsupported file type for ' + url);
  }

  function setLabel(btn, text) {
    var label = btn.querySelector('.pp-resource-btn-label');
    if (label) {
      label.textContent = text;
    }
  }

  function mergeAndOpen(urls, libSrc, btn) {
    var label = btn.querySelector('.pp-resource-btn-label');
    var originalText = label ? label.textContent : null;

    btn.setAttribute('aria-busy', 'true');
    btn.style.pointerEvents = 'none';
    setLabel(btn, 'Preparing PDF\u2026');

    function restore() {
      btn.removeAttribute('aria-busy');
      btn.style.pointerEvents = '';
      if (originalText !== null) setLabel(btn, originalText);
    }

    loadPdfLib(libSrc)
      .then(function () {
        if (!window.PDFLib) throw new Error('pdf-lib did not load');
        return window.PDFLib.PDFDocument.create().then(function (merged) {
          var chain = Promise.resolve();
          urls.forEach(function (url) {
            chain = chain.then(function () {
              return fetch(url).then(function (res) {
                if (!res.ok) throw new Error('Fetch failed for ' + url);
                return res.arrayBuffer();
              }).then(function (bytes) {
                return addToMerged(merged, bytes, url);
              });
            });
          });
          return chain.then(function () { return merged.save(); });
        });
      })
      .then(function (mergedBytes) {
        var blob = new Blob([mergedBytes], { type: 'application/pdf' });
        var blobUrl = URL.createObjectURL(blob);
        window.open(blobUrl, '_blank', 'noopener');
        restore();
      })
      .catch(function (err) {
        console.error('Spec sheet merge failed, opening the first file instead:', err);
        window.open(urls[0], '_blank', 'noopener');
        restore();
      });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-specsheet-urls]');
    if (!btn) return;

    var raw = btn.getAttribute('data-specsheet-urls');
    var libSrc = btn.getAttribute('data-pdf-lib-src');
    if (!raw || !libSrc) return;

    var urls;
    try {
      urls = JSON.parse(raw);
    } catch (err) {
      return; // malformed data - let the plain href open the first file
    }
    if (!urls || urls.length < 2) return;

    e.preventDefault();
    mergeAndOpen(urls, libSrc, btn);
  });
})();
